import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = { class: "bg-light mb-2 py-1 px-2 shadow-sm rounded" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h5", { class: "py-2 mb-3 text-primary border-bottom" }, "Identificação", -1);
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-12" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Nome Completo", -1);
const _hoisted_6 = { class: "col-12" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = {
    key: 0,
    class: "col-12"
};
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Data de Nascimento", -1);
const _hoisted_10 = { class: "row" };
const _hoisted_11 = {
    key: 0,
    class: "col-6"
};
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "CPF", -1);
const _hoisted_13 = { class: "col-6" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Celular", -1);
const _hoisted_15 = { class: "row" };
const _hoisted_16 = {
    key: 0,
    class: "col-12"
};
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "CPF", -1);
const _hoisted_18 = {
    key: 0,
    class: "col-12 mb-2"
};
const _hoisted_19 = { class: "form-check custom-control custom-checkbox" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("label", {
    class: "custom-control-label",
    for: "doacao_anonima"
}, "Não divulgar meu nome na lista de doadores.", -1);
const _hoisted_21 = { class: "col-12" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "E-mail", -1);
const _hoisted_23 = {
    key: 0,
    class: "row mb-3"
};
const _hoisted_24 = { class: "col-12" };
const _hoisted_25 = { class: "form-check custom-control custom-checkbox" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("label", {
    class: "custom-control-label",
    for: "doacao_em_nome_empresa"
}, "Quero doar em nome da minha empresa.", -1);
const _hoisted_27 = {
    key: 1,
    class: "row"
};
const _hoisted_28 = { class: "col-12" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Razão Social", -1);
const _hoisted_30 = { class: "col-12" };
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "CNPJ", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DatetimePicker = _resolveComponent("DatetimePicker");
    const _component_InputMasked = _resolveComponent("InputMasked");
    const _component_DocumentoInput = _resolveComponent("DocumentoInput");
    const _directive_uncapitalize = _resolveDirective("uncapitalize");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                (!_ctx.doacao.doacao_em_nome_empresa)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.doacao.nome) = $event)),
                        required: "",
                        placeholder: "Nome completo como consta em seu CPF"
                    }, null, 512)), [
                        [_vModelText, _ctx.doacao.nome]
                    ])
                    : _createCommentVNode("", true),
                (_ctx.doacao.doacao_em_nome_empresa)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.doacao.responsavel_nome) = $event)),
                        required: "",
                        placeholder: "Nome completo como consta em seu CPF"
                    }, null, 512)), [
                        [_vModelText, _ctx.doacao.responsavel_nome]
                    ])
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    (_ctx.doacao.movimentacao?.forma_pagamento?.data_nascimento_obrigatorio)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _hoisted_9,
                            _createVNode(_component_DatetimePicker, {
                                modelValue: _ctx.doacao.data_nascimento,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.doacao.data_nascimento) = $event)),
                                config: { format: 'DD/MM/YYYY' }
                            }, null, 8, ["modelValue"])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                    (!_ctx.doacao.doacao_em_nome_empresa)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _hoisted_12,
                            _createVNode(_component_InputMasked, {
                                modelValue: _ctx.doacao.cpf_cnpj,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.doacao.cpf_cnpj) = $event)),
                                mask: "###.###.###-##",
                                required: ""
                            }, null, 8, ["modelValue"])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(_component_InputMasked, {
                            modelValue: _ctx.doacao.celular,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.doacao.celular) = $event)),
                            mask: "(##) #####-####",
                            placeholder: "Informe o seu celular ou fixo com ddd",
                            required: ""
                        }, null, 8, ["modelValue"])
                    ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                    (_ctx.doacao.doacao_em_nome_empresa)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _hoisted_17,
                            _createVNode(_component_InputMasked, {
                                modelValue: _ctx.doacao.responsavel_cpf,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.doacao.responsavel_cpf) = $event)),
                                mask: "###.###.###-##",
                                required: ""
                            }, null, 8, ["modelValue"])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            (!_ctx.campanha.is_politica)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                        _withDirectives(_createElementVNode("input", {
                            id: "doacao_anonima",
                            name: "doacao_anonima",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.doacao.doacao_anonima) = $event)),
                            class: "custom-control-input",
                            type: "checkbox"
                        }, null, 512), [
                            [_vModelCheckbox, _ctx.doacao.doacao_anonima]
                        ]),
                        _hoisted_20
                    ])
                ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.doacao.email) = $event)),
                    required: "",
                    placeholder: "Informe o seu melhor e-mail"
                }, null, 512), [
                    [_vModelText, _ctx.doacao.email],
                    [_directive_uncapitalize]
                ])
            ])
        ]),
        (!_ctx.campanha.is_politica)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                        _withDirectives(_createElementVNode("input", {
                            id: "doacao_em_nome_empresa",
                            name: "doacao_em_nome_empresa",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.doacao.doacao_em_nome_empresa) = $event)),
                            class: "custom-control-input",
                            type: "checkbox",
                            onChange: _cache[9] || (_cache[9] = ($event) => (_ctx.changeDoacaoEmpresa()))
                        }, null, 544), [
                            [_vModelCheckbox, _ctx.doacao.doacao_em_nome_empresa]
                        ]),
                        _hoisted_26
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.doacao.doacao_em_nome_empresa)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        required: "",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.doacao.nome) = $event)),
                        placeholder: "Informe a razão social da empresa"
                    }, null, 512), [
                        [_vModelText, _ctx.doacao.nome]
                    ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createVNode(_component_DocumentoInput, {
                        modelValue: _ctx.doacao.cpf_cnpj,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.doacao.cpf_cnpj) = $event)),
                        tipo: "cnpj",
                        placeholder: "Informe o CNPJ da empresa",
                        required: ""
                    }, null, 8, ["modelValue"])
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
